import { ReactElement, useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";

import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "./QueryClient";
import appRoutes from "./routes";

import SplashScreen from "@components/common/SplashScreen";

import { API_CARRIER_PREFERENCES, CARRIER_PREFERENCES_QUERY_KEY } from "@utils/Constants";
import { fetchData } from "@utils/HttpHelpers";

import { AppNotificationProvider, TAppNotification } from "@context/AppNotification";

const App = (): ReactElement => {
  const [notification, setNotification] = useState<TAppNotification>(null);

  useEffect(() => {
    queryClient.prefetchQuery({
      queryKey: [CARRIER_PREFERENCES_QUERY_KEY],
      queryFn: () => {
        return fetchData(API_CARRIER_PREFERENCES);
      },
    });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AppNotificationProvider value={{ notification, setNotification }}>
        <RouterProvider router={appRoutes} fallbackElement={<SplashScreen />} />
      </AppNotificationProvider>
    </QueryClientProvider>
  );
};

export default App;
